import React from "react";
import Card from "react-bootstrap/Card";
import { CgPentagonRight } from "react-icons/cg";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">piyush Senjaliya </span>
            from <span className="purple"> Ahmedabad, India.</span>
            <br />
            I am currently employed as a software developer.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <CgPentagonRight /> Playing Games
            </li>
            <li className="about-activity">
              <CgPentagonRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <CgPentagonRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Piyush</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
